import { getDatasWithOption, handleApiError } from '../../utils/service';
import { isDefined, isFunction, isString, isObject, not, isNotDefined, parseInt10, truthy, falsy, each, allOf, getUriParams, getUriCombinedParams, getFirstObjectHasProperty, getObjectHasProperty, getUrlAddCategoryIdByArticle, anyOf } from '../../utils/util';
import { API_DOMAIN_DEFAULT , API_COMMUNITY_DOMAIN  } from '../../model/model';
import { getServermasterNewArticleTpl, getMyServermasterTpl } from './tpl';
import ServerMasterNewArticle from './ServerMasterNewArticle';

class ServerMasterList {
  constructor(options) {
    const _ = this;

    if (isNotDefined(options)) throw new Error('ServerList constructor require options object');

    _.option = $.extend({
      wrap: null,
      apiDomain: '' || API_COMMUNITY_DOMAIN,
      hostApiDomain: '' || API_DOMAIN_DEFAULT,
      ncCommunityList: null,

      isShowServerMasterArticles: false,
      isIngame: false,

      serverAlias: 0, // this is serverId

      global: window
    }, options);

    console.log('# serverlist _.option : ', _.option );

    _.wrap = _.option.wrap;

    _.serverId = parseInt10(_.option.serverAlias);

    _.device = null;

    _.servermasterWrap = null;

    _.servermasterNewArticle = null;

    _.global = _.option.global;

    _.const = {
      MILLISECOND_TO_DAY: 1000 * 60 * 60 * 24
    };

    _.msg = {
      FAIL_LOAD_SERVERMASTER_DATA: '서버지기 데이터를 로드할 수 없습니다. 잠시 후 다시 시도해주세요.',
      FAIL_LOAD_MY_SERVERMASTER_ARTICLES: '우리 서버 최신 기사 데이터를 로드할 수 없습니다. 잠시 후 다시 시도해주세요.'
    };

    _.masters = [];
    _.flag = false;
    _.setServerId = 0;


  }

  init() {

    console.log( '#serverList.js init()' );
    const _ = this;

    if (isNotDefined(_.option.ncCommunityList)) throw new Error('ServerList constructor require options has ncCommunityList parameter');

    // 검색 결과에서는 서버지기 노출되지않음
    const uriParams = getUriParams(document.location.href) || {},
        metaTags = uriParams.metaTags; // metaTags
    if( metaTags ) return ;

    // after initialize ncCommunityList, call setInstance method

    // _.option.ncCommunityList.onLoaded.add(_.setInstance, _);

    _.setInstance();
    return _;
  }

  setInstance() {
    const _ = this;

    _.setServerId = _.getServerId();

    console.log( '#serverList.js setInstance() _.masters.length , _.setServerId ', _.masters.length , _.setServerId , parseInt(_.setServerId) == 0);

    if( _.masters.length <= 0 ) {

      // api - http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=97027727
      // api/servermaster/1/isServerMaster
      getDatasWithOption([{
        type: 'GET',
        contentType: 'application/json',
        dataType: 'json',
        url: `${_.option.hostApiDomain}api/servermaster/serverMastersByServerId?serverId=${_.getServerId()}`,
        // data: {serverId: _.getServerId()}

      }], (masters) => {

        console.log(masters);

        _.masters = masters;
        _.setContents();
      }, (data) => {
        _.setContents();
      });

    } else {
      _.setContents();
    }


  }

  setContents() {
    const _ = this;


    _.setMasterWrittenItemColor();

    // my server new articles
    const uriParams = getUriParams(document.location.href) || {};

    console.log( '#ServerMasterList.js  _.global._serverNameMap, _.serverId ', _.global._serverNameMap,  _.serverId );

    let _getInitServerName = _.global._boardCategoryMap ? Object.getOwnPropertyNames(_.global._boardCategoryMap[0]) : ['데포로쥬'];
    let _getServerName = getFirstObjectHasProperty(_.global._serverNameMap, 'serverId', _.serverId) ? getFirstObjectHasProperty(_.global._serverNameMap, 'serverId', _.serverId).serverName : null;
    let _serverName =  _getServerName ? _getServerName : _getInitServerName[0];
    let _categoryId = getObjectHasProperty(_.global._boardCategoryMap , _serverName);

    let categoryId = uriParams.categoryId || _categoryId;
    let metaTags = uriParams.metaTags;

    console.log('# serverList.js setContents(), serverName, Category', _serverName, _categoryId, categoryId);

    if( !categoryId ) return;
    if( metaTags ) return ;

    if(categoryId <= 0) {
      // all server. don't set servermaster article UI

    } else {
      // some server
      if(! _.flag)
        if (truthy(_.option.isShowServerMasterArticles)) _.setServermasterArticles();
    }

    _.flag = true;

  }

  setMasterWrittenItemColor() {

    console.log('#serverlist.js setMasterWrittenItemColor() start');
    const _ = this;

    const $masterList = $('.ncCommunityBoardList .board-items', _.wrap).filter(function () {
      console.log( 'data-master attribute value :', $(this).is('[data-is-master]'));
      return $(this).is('[data-is-master]');
    });

    if ($masterList.length <= 0) {
      // no item server master have written
      console.log('no item which server master have written');
      return;
    }

    if (_.masters.length <= 0) {
      console.log('no server master in this server');
      return;
    }

    // has item master have written

    let mastersCash = {};

    console.log ('#serverlist.js setMasterWrittenItemColor() $masterList : ', $masterList);

    $masterList.each(function (index, value) {
      const nameNode = $('.board-meta .name', value).contents().filter(function (i, v) { // isDefaultViewMode: "classic" 일경우, compact 모드일경우는 셀렉터가 다름
            return v.nodeType === Node.TEXT_NODE;
          }),
          name = nameNode.text(),
          masterObj = mastersCash[name] || getFirstObjectHasProperty(_.masters, 'characterName', name);

      if (masterObj) {
        // server master has name
        $(value).attr('data-is-master', masterObj.category.toLowerCase()); // review, column, coverage

        if (!mastersCash[name]) mastersCash[name] = masterObj;
      }
    });
  }

  setServermasterArticles() {
    const _ = this;
    console.log('# serverList.js setServermasterArticles(), start');

    // servermaster section
    $('#boardTopUtils').after('<div class="wrap-servermaster"><a class="btn-servermaster" href="/servermaster/index">서버지기 모집안내</a><div class="wrap-section-servermaster"></div></div>');

    _.servermasterParent = $('.wrap-servermaster');
    _.servermasterWrap = $('.wrap-section-servermaster');

    if (falsy(_.option.isIngame)) {
      // pc, mobile

      // set my server masters - modify 5/3
      _.setMyServerMaster(_.masters);

      if( _.option.device === 'pc' || _.option.device === 'launcher' ) _.servermasterWrap.append(getServermasterNewArticleTpl());

      // get servermaster new articles
      getDatasWithOption([{
        type: 'GET',
        contentType: 'application/json',
        url: `${_.option.apiDomain}board/server/article/search/moreArticle`,
        dataType: 'json',
        data: {
          moreSize: 12,
          // page: 1,
          // query: '서버지기',
          // searchType: 'metaTags',
          metaTags: 'servermaster',
          categoryId: 0, // all server board category id
          summary: false
        },
        xhrFields: {withCredentials: true}

      }], (articleData) => {

        console.log( '# serverlist.js setServermasterArticles() articleData : ', articleData );

        _.servermasterParent.addClass(_.option.device);

        _.servermasterNewArticle = new ServerMasterNewArticle({
          wrap: $('.section-servermaster', _.servermasterWrap),
          device: _.option.device,
          data: articleData
        }).init();

        // set my server masters
        /* _.setMyServerMaster(_.masters); */



      }, (data) => {
        if (falsy(handleApiError(data))) _.global.alert(_.msg.FAIL_LOAD_SERVERMASTER_DATA); // '서버지기 데이터를 로드할 수 없습니다. 잠시 후 다시 시도해주세요.'
      });

    } else {
      // ingame
      _.servermasterWrap.addClass('is-ingame');

      // set servermaster new articles
      if (not(Array.isArray)(_.masters)) {
        // no process
      } else {
        if (_.masters.length <= 0) {
          _.servermasterWrap.remove();

        } else {
          _.setMyServerMaster(_.masters);
        }
      }

    }
  }

  setMyServerMaster(_data) {
    const _ = this,
        data = _data || [];

    console.log( 'serverList.js setMyServerMaster() _.setServerId : ', _.setServerId , parseInt(_.setServerId) == 0);
    if (data.length <= 0 || parseInt(_.setServerId) == 0 ) return;

    // set my server servermaster

    _.servermasterParent.addClass('has-servermaster');
    _.servermasterWrap.append(getMyServermasterTpl());


    // my server masters
    let tpl = '';
    each(data, (item) => {
      tpl += `<li><span class="flag ${item.category}"></span> ${item.characterName} </li>`;
    });

    $('.section-servermaster-my .article-myservermaster ul', _.servermasterWrap).append(tpl);

    // my server new articles
    const uriParams = getUriParams(document.location.href) || {};


    //let _serverName = getFirstObjectHasProperty(_.global._serverNameMap, 'serverId', _.serverId).serverName;
    //let _categoryId = getObjectHasProperty(_.global._boardCategoryMap , _serverName);
    let _getInitServerName = _.global._boardCategoryMap ? Object.getOwnPropertyNames(_.global._boardCategoryMap[0]) : ['데포로쥬'];
    let _getServerName = getFirstObjectHasProperty(_.global._serverNameMap, 'serverId', _.serverId) ? getFirstObjectHasProperty(_.global._serverNameMap, 'serverId', _.serverId).serverName : null;
    let _serverName =  _getServerName ? _getServerName : _getInitServerName[0];
    let _categoryId = getObjectHasProperty(_.global._boardCategoryMap , _serverName);

    let categoryId = uriParams.categoryId || _categoryId;

    console.log('# serverList.js setMyServerMaster(), serverName, Category', _serverName, _categoryId, categoryId);

    /*if (isNaN(categoryId)) {
      categoryId = getFirstObjectHasProperty(_.global._serverNameMap, 'serverId', _.serverId).categoryId || _.global._serverNameMap[0].categoryId;
    }*/

    getDatasWithOption([{
      type: 'GET',
      contentType: 'application/json',
      url: `${_.option.apiDomain}board/server/article/search/moreArticle`,
      dataType: 'json',
      data: {
        moreSize: 3,
        // page: 1,
        // query: '서버지기',
        // searchType: 'metaTags',
        metaTags: 'servermaster',
        categoryId: categoryId,
        summary: false
      },
      xhrFields: {withCredentials: true}

    }], (articleData) => {

      console.log('# serverList.js setMyServerMaster() articleData.contentList: ', articleData.contentList );

      if (Array.isArray(articleData.contentList) && articleData.contentList.length > 0) {
        let tpl = '', url;
        each(articleData.contentList, (article) => {
          const diff = new Date(_.global.userData.now).getTime() - new Date(article.postDate).getTime(),
              newIconTpl = (diff < _.const.MILLISECOND_TO_DAY) ? ' <i class="fe-icon-new"></i> ' : '';

          /* let url = (article.url || '').split('/').pop() || '#';
          url = getUrlAddCategoryIdByArticle(url, article, _.global._serverNameMap); // */
          url = `view?categoryId=${article.categoryBoard.id}&articleId=${article.id}`;

          tpl += `<li><a class="title" href="${url}">${article.title}${newIconTpl}</a><span class="writer">${article.writer.gameUser.gameCharacterName}</span></li>`;
        });

        $('.section-servermaster-my .article-list ul', _.servermasterWrap).append(tpl);

      } else {
        $('.section-servermaster-my .article-list ul', _.servermasterWrap).append(`<li class="nodata">작성된 기사가 없습니다.</li>`);
      }

    }, function (data) {
      if (falsy(handleApiError(data))) _.global.alert(_.msg.FAIL_LOAD_MY_SERVERMASTER_ARTICLES); // '우리 서버 최신 기사 데이터를 로드할 수 없습니다. 잠시 후 다시 시도해주세요.'
    });
  }

  getServerId() {
    const _ = this;

    let selectedOption = null,
        dropdownCategoryId = null,
        dropdownServerName = null;
    if (anyOf($('body').hasClass('mobile'), $('body').hasClass('tablet'))) {
      // mobile device
      selectedOption = $('#boardCategory .ui-dropdown-elements select option:selected');
      dropdownCategoryId = selectedOption.val();
      dropdownServerName = selectedOption.text();

    } else {
      // pc device
      const dropdownSelectedServerName = $('.board-top-category .ui-dropdown > span').text(),
          dropdownOptions = $('.board-top-category .ui-dropdown .option li');

      for (let i = 0, max = dropdownOptions.length; i < max; i++) {
        if ($(dropdownOptions.get(i)).text() === dropdownSelectedServerName ) {
          selectedOption = $(dropdownOptions.get(i));
          break;
        }
      }
      dropdownCategoryId = selectedOption.attr('data-value');
      dropdownServerName = selectedOption.attr('data-textvalue');
    }

    // my server new articles
    const uriParams = getUriParams(document.location.href) || {},
        categoryId = uriParams.categoryId;

    let serverId = 0;

    if (categoryId) {
      const data = getFirstObjectHasProperty(_.global._serverNameMap, 'serverName', dropdownServerName) || {};
      serverId = data.serverId || 0; // some server id || 'all'
    } else {
      serverId = _.serverId || 0; // if (isNotDefined(_.global.userData) || isNotDefined(_.global.userData.gameAccount) || _.global.userData.gameAccount.serverId !== '') serverId = _.global.userData.gameAccount.serverId;
    }

    return serverId;
  }
}

export default ServerMasterList;


// WEBPACK FOOTER //
// ./_src/js/board/servermaster/ServerMasterList.js